import React from 'react';
import { useChatContext } from 'contexts/ChatContext';
import AGMessage from 'components/AGMessage/AGMessage';
import DashboardContent from 'components/Dashboard/DashboardContent/DashboardContent';
import MessageList from './MessageList';
import ChatInput from './ChatInput';
import SuggestedQuestions from './SuggestedQuestions';
import styles from './ChatPage.module.css';

const ChatPage: React.FC = () => {
    const { messages, isStreaming, activeTools, error, sendMessage } = useChatContext();
    const hasMessages = messages.length > 0;

    return (
        <DashboardContent title="Chat">
            <div className={`${styles.container} ${!hasMessages ? styles.empty : ''}`}>
                <div className={styles.chatArea}>
                    {hasMessages ? (
                        <MessageList messages={messages} isStreaming={isStreaming} activeTools={activeTools} />
                    ) : (
                        <SuggestedQuestions onSelect={sendMessage} />
                    )}
                </div>
                {error && <AGMessage color="error">{error}</AGMessage>}
                <ChatInput onSend={sendMessage} disabled={isStreaming} />
            </div>
        </DashboardContent>
    );
};

export default ChatPage;
